import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { FaEdit, FaTrashAlt } from 'react-icons/fa';
import { getBaseUrl } from "../global/Globalapi";
const RegionMasterForm = () => {
  const [formData, setFormData] = useState({
    region_name: '',
    region_des: '',
    region_alies: '',
    cmp_id: ''
  });

  const [companies, setCompanies] = useState([]);
  const [regions, setRegions] = useState([]);
  const [editId, setEditId] = useState(null);
  const [message, setMessage] = useState({ type: '', text: '' });
  const [loading, setLoading] = useState(false);

  // Backend URL on port 5000
  // const API_BASE_URL = 'http://localhost:5000';
const API_BASE_URL = getBaseUrl();
  // Fetch companies and regions on component mount
  useEffect(() => {
    fetchCompanies();
    fetchRegions();
  }, []);

  const fetchCompanies = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/companymaster`);
      setCompanies(response.data);
    } catch (error) {
      console.error('Error fetching companies:', error);
    }
  };

  const fetchRegions = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/regionmaster`);
      setRegions(response.data);
    } catch (error) {
      console.error('Error fetching regions:', error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage({ type: '', text: '' });
    
    try {
      if (editId) {
        // Update existing region
        await axios.put(`${API_BASE_URL}/api/regionmaster/${editId}`, formData, {
          headers: { 'Content-Type': 'application/json' },
          timeout: 10000
        });
        setMessage({ type: 'success', text: 'Region updated successfully!' });
      } else {
        // Create new region
        await axios.post(`${API_BASE_URL}/api/regionmaster`, formData, {
          headers: { 'Content-Type': 'application/json' },
          timeout: 10000
        });
        setMessage({ type: 'success', text: 'Region saved successfully!' });
      }
      handleReset();
      fetchRegions(); // Refresh the list
    } catch (error) {
      console.error('Error details:', error);
      const errorMsg = error.response?.data?.message || 'Error saving region';
      setMessage({ type: 'error', text: errorMsg });
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (region) => {
    setEditId(region.region_id);
    setFormData({
      region_name: region.region_name || '',
      region_des: region.region_des || '',
      region_alies: region.region_alies || '',
      cmp_id: region.cmp_id || ''
    });
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleDelete = async (regionId) => {
    if (!window.confirm('Are you sure you want to delete this region?')) return;
    
    try {
      await axios.delete(`${API_BASE_URL}/api/regionmaster/${regionId}`);
      setMessage({ type: 'success', text: 'Region deleted successfully!' });
      fetchRegions();
    } catch (error) {
      console.error('Error deleting region:', error);
      const errorMsg = error.response?.data?.message || 'Error deleting region';
      setMessage({ type: 'error', text: errorMsg });
    }
  };

  const handleReset = () => {
    setEditId(null);
    setFormData({
      region_name: '',
      region_des: '',
      region_alies: '',
      cmp_id: ''
    });
  };

  // Helper to get company name by ID
  const getCompanyName = (cmpId) => {
    const company = companies.find(c => c.company_id === cmpId);
    return company ? company.company_name : '-';
  };

  const inputStyle = {
    width: '100%',
    padding: '10px',
    margin: '10px 0',
    border: '1px solid #ddd',
    borderRadius: '4px',
    fontSize: '16px'
  };

  const labelStyle = {
    fontWeight: 'bold',
    display: 'block',
    marginBottom: '5px'
  };

  return (
    <div style={{ maxWidth: '900px', margin: '50px auto', padding: '20px' }}>
      {/* Form Section */}
      <div style={{
        padding: '30px',
        border: '1px solid #ddd',
        borderRadius: '8px',
        backgroundColor: '#f9f9f9',
        marginBottom: '30px'
      }}>
        <h2 style={{ textAlign: 'center', marginBottom: '30px', color: '#333', borderBottom: '2px solid #4CAF50', paddingBottom: '10px' }}>
          {editId ? 'Edit Region' : 'Add Region'}
        </h2>
      
        {message.text && (
          <div style={{
            padding: '10px',
            marginBottom: '20px',
            borderRadius: '4px',
            backgroundColor: message.type === 'success' ? '#d4edda' : '#f8d7da',
            color: message.type === 'success' ? '#155724' : '#721c24',
            border: message.type === 'success' ? '1px solid #c3e6cb' : '1px solid #f5c6cb'
          }}>
            {message.text}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div>
            <label style={labelStyle}>Region Name *</label>
            <input
              type="text"
              name="region_name"
              value={formData.region_name}
              onChange={handleChange}
              style={inputStyle}
              placeholder="Enter region name"
              required
              maxLength="100"
            />
          </div>

          <div>
            <label style={labelStyle}>Region Description *</label>
            <textarea
              name="region_des"
              value={formData.region_des}
              onChange={handleChange}
              style={{ ...inputStyle, minHeight: '100px' }}
              placeholder="Enter region description"
              required
              maxLength="200"
            />
          </div>

          <div>
            <label style={labelStyle}>Region Alias *</label>
            <input
              type="text"
              name="region_alies"
              value={formData.region_alies}
              onChange={handleChange}
              style={inputStyle}
              placeholder="Enter region alias"
              required
              maxLength="15"
            />
          </div>

          <div>
            <label style={labelStyle}>Company *</label>
            <select
              name="cmp_id"
              value={formData.cmp_id}
              onChange={handleChange}
              style={inputStyle}
              required
            >
              <option value="">Select Company</option>
              {companies.map(company => (
                <option key={company.company_id} value={company.company_id}>
                  {company.company_name} ({company.company_code})
                </option>
              ))}
            </select>
          </div>

          <div style={{ marginTop: '30px', textAlign: 'center' }}>
            <button type="submit" disabled={loading} style={{
              backgroundColor: loading ? '#ccc' : '#4CAF50',
              color: 'white',
              padding: '12px 24px',
              border: 'none',
              borderRadius: '4px',
              cursor: loading ? 'not-allowed' : 'pointer',
              fontSize: '16px',
              marginRight: '10px'
            }}>
              {loading ? 'Saving...' : (editId ? 'Update Region' : 'Save Region')}
            </button>
            <button 
              type="button" 
              style={{
                backgroundColor: '#f44336',
                color: 'white',
                padding: '12px 24px',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                fontSize: '16px'
              }}
              onClick={handleReset}
            >
              {editId ? 'Cancel' : 'Reset'}
            </button>
          </div>
        </form>
      </div>

      {/* Region List Section */}
      <div style={{
        padding: '30px',
        border: '1px solid #ddd',
        borderRadius: '8px',
        backgroundColor: '#fff',
        boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
      }}>
        <h3 style={{ 
          marginBottom: '20px', 
          color: '#333',
          borderBottom: '2px solid #2196F3',
          paddingBottom: '10px'
        }}>
          Region 
        </h3>

        {regions.length === 0 ? (
          <p style={{ textAlign: 'center', color: '#666' }}>No regions found.</p>
        ) : (
          <div style={{ overflowX: 'auto' }}>
            <table style={{ 
              width: '100%', 
              borderCollapse: 'collapse',
              fontSize: '14px'
            }}>
              <thead>
                <tr style={{ backgroundColor: '#b91c1c', color: 'white' }}>
                  <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #ddd' }}>S.No</th>
                  <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #ddd' }}>Region Name</th>
                  <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #ddd' }}>Description</th>
                  <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #ddd' }}>Alias</th>
                  <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #ddd' }}>Company</th>
                  <th style={{ padding: '12px', textAlign: 'center', borderBottom: '2px solid #ddd' }}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {regions.map((region, index) => (
                  <tr key={region.region_id} style={{ 
                    backgroundColor: index % 2 === 0 ? '#f9f9f9' : '#fff',
                    borderBottom: '1px solid #ddd'
                  }}>
                    <td style={{ padding: '12px' }}>{index + 1}</td>
                    <td style={{ padding: '12px' }}>{region.region_name}</td>
                    <td style={{ padding: '12px' }}>{region.region_des}</td>
                    <td style={{ padding: '12px' }}>{region.region_alies}</td>
                    <td style={{ padding: '12px' }}>{getCompanyName(region.cmp_id)}</td>
                    <td style={{ padding: '12px', textAlign: 'center' }}>
                      <button
                        onClick={() => handleEdit(region)}
                        style={{
                          backgroundColor: '#2196F3',
                          color: 'white',
                          border: 'none',
                          padding: '8px 12px',
                          borderRadius: '4px',
                          cursor: 'pointer',
                          marginRight: '8px'
                        }}
                        title="Edit Region"
                      >
                        <FaEdit />
                      </button>
                      <button
                        onClick={() => handleDelete(region.region_id)}
                        style={{
                          backgroundColor: '#f44336',
                          color: 'white',
                          border: 'none',
                          padding: '8px 12px',
                          borderRadius: '4px',
                          cursor: 'pointer'
                        }}
                        title="Delete Region"
                      >
                        <FaTrashAlt />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default RegionMasterForm;